/**
 * Tiny form-field primitives shared across MainSettings panels
 * (LogoRingPanel, SectionLayoutControls, CtaLayoutPanel, ChampionBadgePanel,
 * SiteThemePanel, HeroImageControls, GlobalLayoutPresets, …).
 */
import React from "react";
import { Label } from "@/components/ui/label";

export function SelectField({ label, value, onChange, options, testid }) {
  return (
    <div>
      <Label className="text-xs text-slate-600">{label}</Label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full h-9 rounded-md border border-slate-200 bg-white px-2 text-sm"
        data-testid={testid}
      >
        {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

export function RangeField({ label, value, min, max, unit, onChange, testid }) {
  return (
    <div>
      <Label className="text-xs text-slate-600">{label} <span className="text-slate-400">({value}{unit})</span></Label>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full mt-2 accent-teal-600"
        data-testid={testid}
      />
    </div>
  );
}

export function ColorField({ label, value, onChange, testid }) {
  return (
    <div>
      <Label className="text-xs text-slate-600">{label}</Label>
      <div className="mt-1 flex items-center gap-2 rounded-md border border-slate-200 px-2 py-1.5 bg-white">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-7 h-7 rounded cursor-pointer border border-slate-200"
          data-testid={`${testid}-picker`}
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 text-sm font-mono text-slate-600 bg-transparent outline-none"
          data-testid={`${testid}-hex`}
        />
      </div>
    </div>
  );
}
